import { render, staticRenderFns } from "./IronDate4.vue?vue&type=template&id=1a53a8e2&"
import script from "./IronDate4.vue?vue&type=script&lang=js&"
export * from "./IronDate4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports